import type { SVGProps } from "react";
export interface UfoIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function UfoIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: UfoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 10.5c0-1.278.977-2.18 1.95-2.753 1.035-.61 2.433-1.078 4.012-1.393a1.125 1.125 0 1 1 .44 2.206c-1.442.287-2.571.69-3.31 1.125-.794.468-.841.784-.842.814 0 .014.005.189.378.497.365.302.962.624 1.797.917 1.662.581 4.031.962 6.7.962s5.038-.38 6.7-.962c.835-.293 1.431-.615 1.797-.917.372-.308.378-.482.378-.497-.001-.03-.048-.346-.841-.814-.646-.38-1.593-.737-2.785-1.012l-.526-.113-.111-.028a1.125 1.125 0 0 1 .438-2.196l.113.018.584.124c1.34.31 2.522.735 3.428 1.269.973.573 1.95 1.475 1.95 2.752 0 .953-.555 1.7-1.194 2.23-.647.535-1.514.967-2.488 1.308-.389.136-.807.255-1.246.368l1.88 6.272.028.111a1.125 1.125 0 0 1-2.144.643l-.038-.108-1.944-6.476a28 28 0 0 1-3.978.278 28 28 0 0 1-3.982-.278l-1.94 6.476-.04.108a1.125 1.125 0 0 1-2.117-.754l1.88-6.27a16 16 0 0 1-1.244-.37c-.974-.34-1.842-.773-2.49-1.308-.639-.53-1.193-1.277-1.193-2.23Z"
      />
      <path
        fill={color}
        d="M12.141 17.632a1.375 1.375 0 1 1-1.509 1.51L10.625 19l.007-.14a1.375 1.375 0 0 1 1.369-1.235zm-.14-15.757c3.269 0 5.868 2.639 6.107 5.883a1.9 1.9 0 0 1-.73 1.648c-.767.594-2.59 1.72-5.377 1.72S7.389 10 6.621 9.406a1.9 1.9 0 0 1-.727-1.648l.029-.303c.373-3.104 2.91-5.58 6.078-5.58m0 2.25c-1.935 0-3.605 1.536-3.844 3.615.592.42 1.887 1.135 3.844 1.135 1.954 0 3.248-.716 3.84-1.135-.24-2.079-1.906-3.615-3.84-3.615"
      />
    </svg>
  );
}
